<template>
    <div class="bbyklist2">
        <el-card>
            <main>
                <el-select v-if="type_show" v-model="type" placeholder="类型" clearable style="margin-bottom:10px" @change="getType()">
                    <el-option label="消费" value="10"></el-option>
                    <el-option label="充值" value="20"></el-option>
                </el-select>

                <el-select v-else="type_show"   v-model="type" placeholder="类型" clearable style="margin-bottom:10px" @change="getType2()">
                    <el-option label="消费" value="20"></el-option>
                    <el-option label="充值" value="30"></el-option>
                </el-select>

                <van-cell title="日期" :value="date" @click="show = true" style="padding:0" />
                <van-calendar v-model="show" type="range" @confirm="onConfirm" :min-date="minDate" />
                <h4 style="color:#F56C6C;font-size:14px">{{ org }}</h4>
            </main>

            <el-table
                v-if="type_show"
                algin=center
                stripe
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="list">

                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>

                <el-table-column
                    prop="num"
                    width="160"
                    label="卡号">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==10" style="color: #67C23A;font-weight:600">{{scope.row.num}}</span>
                        <span v-if="scope.row.type==20" style="color: #F56C6C;font-weight:600">{{scope.row.num}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="chepai"
                    width="90"
                    label="车牌">
                </el-table-column>

                <el-table-column
                    width="120"
                    prop="time"
                    label="业务时间">
                </el-table-column>

                <el-table-column
                    prop="q_money"
                    label="操作前">
                </el-table-column>

                <el-table-column
                    prop="money"
                    label="金额">
                </el-table-column>

                <el-table-column
                    prop="h_money"
                    label="操作后">
                </el-table-column> 

                <el-table-column
                    prop="fangshi"
                    label="方式">
                </el-table-column>

                <el-table-column
                    prop="beizhu"
                    label="备注">
                </el-table-column>

                <el-table-column label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type==10" style="color: #67C23A;">消费</span>
                        <span v-if="scope.row.type==20" style="color: #F56C6C;">充值</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="operate"
                    label="操作人">
                </el-table-column>
            </el-table>

            <el-table
                v-else
                algin=center
                stripe
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="list">
                
                <el-table-column
                    width="150"
                    prop="num"
                    label="卡号">
                </el-table-column>

                <el-table-column
                    prop="time"
                    width="120"
                    label="业务时间">
                </el-table-column>

                <el-table-column
                    prop="money"
                    width="80"
                    label="金额">
                </el-table-column>

                <el-table-column
                    prop="operate"
                    width="100"
                    label="操作人">
                </el-table-column>

                <el-table-column
                    prop="type"
                    width="100"
                    label="类型">
                </el-table-column>

            </el-table>

            <br/>
            <br/>
            <span style="color: #67C23A;font-weight:600;font-size:16px">支出:{{ all_zc }}</span>
            <span style="color: #F56C6C;font-weight:600;font-size:16px;margin-left:60px">充值:{{ all_cz }}</span>

        </el-card>
    </div>
</template>

<script>
import { ykMingxi,ykMingxi2 } from '../router/api';

export default {
    data() {
        return {
            show: false,
            type:'',            
            list: [],
            date:'',
            minDate: new Date(2023, 1, 1),
            org:'',
            num:'',
            all_zc:'',
            all_cz:'',
            zfk:'',
            type_show:true,
        };
    },
  
    mounted() {
        this.num = this.$route.query.num
        this.org = this.$route.query.org
        this.zfk = this.$route.query.type

        var date = new Date();
        date.setTime(date.getTime());
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
        var time1 = Y + M + '01'
        var time2 = Y + M +D
        this.date = time1 + ' - ' + time2 
        if(this.zfk=='主卡') {
            this.type_show = false
            this.getZhu()
        } else {
            this.type_show = true
            this.getList()    
        }
    },

    methods: {

        getType() {
            if(this.zfk=='主卡') {
                this.getZhu()
            } else {
                this.getList()    
            }
        },

        getType2() {
            if(this.zfk=='主卡') {
                this.getZhu()
            } else {
                this.getList()    
            }
        },


        formatDate(date) {
            var Y = date.getFullYear() + "-"; 
            var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
            var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var day =  Y + M + D
            return day
        },

        onConfirm(date) {
            const [start, end] = date;
            this.show = false;
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
            if(this.zfk=='主卡') {
                this.getZhu()
            } else {
                this.getList()    
            }
        },

        getZhu() {
            var time1 = this.date.split(' - ')[0] + ' 00:00:00'
            var time2 = this.date.split(' - ')[1] + ' 23:59:59'
            ykMingxi2({
                    num:this.num,
                    crate_time1:time1,
                    crate_time2:time2,
                    type:this.type,
                }).then(res=> {
                    if(res.code==1) {
                        this.list = res.data
                        this.all_zc = 0
                        this.all_cz = 0
                        this.list.map(item=> {
                            if(item.type == 20) {
                                item.type = '支出'
                                this.all_zc += Number(item.money)
                            }
                            if(item.type == 30) {
                                item.type = '充值'
                                this.all_cz += Number(item.money)
                            }
                        })
                        this.all_zc = this.all_zc.toFixed(2)
                        this.all_cz = this.all_cz.toFixed(2)
                    }
                }).catch(err=> {
                    console.log(err);
                });
        },

        getList() {
            var time1 = this.date.split(' - ')[0] + ' 00:00:00'
            var time2 = this.date.split(' - ')[1] + ' 23:59:59'
            ykMingxi({
                num:this.num,
                crate_time1:time1,
                crate_time2:time2,
                type:this.type,
            }).then(res=> {
                if(res.code==1) {
                    this.list = res.data
                    this.all_zc = 0
                    this.all_cz = 0
                    this.list.map(item=> {
                        if(item.type == 10) {
                            this.all_zc += Number(item.money)
                        }
                        if(item.type == 20) {
                            this.all_cz += Number(item.money)
                        }
                    })
                    this.all_zc = this.all_zc.toFixed(2)
                    this.all_cz = this.all_cz.toFixed(2)
                }
            }).catch(err=> {
                console.log(err);
            });
        },
       
    },
};
</script>
<style lang="less" scoped>
.bbyklist2 .el-table {
    border: solid 1px black
}
</style>
